import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';

import OneVideo from '@/modules/module-oneVideo';
import OneTabSystem from '@/modules/module-oneTabSystem';

import '../../styles/pages/home.scss';
import '../../styles/pages/additionalContent.scss';

export default Backbone.View.extend({
  initialize: function (opts) {
    console.log('init additional content');

    var self = this;
    self.$content = self.$el;
    self.$body = $('body');
    self.$moduleA = self.$content.find('.hp-module-a');
    self.$additionalModule1 = self.$content.find('.additional-module-1');
    self.$additionalModule2 = self.$content.find('.additional-module-2');
    self.$testimonialsCarouselModule = self.$content.find(
      '.testimonials-carousel-module'
    );
    self.$aboutModuleC = self.$content.find('.about-module-c');
    self.$aboutModuleE = self.$content.find('.about-module-e');

    if (self.$moduleA.length > 0) {
      self.moduleA();
    }
    if (self.$additionalModule1.length > 0) {
      self.additionalModule1();
    }
    if (self.$additionalModule2.length > 0) {
      self.additionalModule2();
    }
    if (self.$testimonialsCarouselModule.length > 0) {
      self.homepageTestimonialsCarouselModule();
    }

    if (self.$aboutModuleC.length > 0) {
      self.aboutModuleC();
    }

    if (self.$aboutModuleE.length > 0) {
      self.aboutModuleE();
    }

    self.accordionsAndTabs();

    self.responsive();
  },

  events: {},

  moduleA: function () {
    var self = this;
    var $videos = self.$moduleA.find('.video-wrapper');

    self.$moduleA.slick({
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      arrows: false
    });

    OneVideo.init({
      el: $videos,
      isResponsive: false,
      bgVideo: true,
      autoplay: true
    });
  },

  additionalModule1: function () {
    var self = this;
    var $slider = self.$additionalModule1.find('.slider.slick');
    var $arrowsContainer = self.$additionalModule1.find('.arrows');

    $slider.slick({
      dots: false,
      infinite: false,
      speed: 600,
      slidesToShow: 1,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      appendArrows: $arrowsContainer,
      adaptiveHeight: true
    });
  },

  additionalModule2: function () {
    var self = this;
    var $videos = self.$additionalModule2.find('.video-wrapper');

    $.each($videos, function (key, video) {
      var $video = $(video);

      OneVideo.init({
        el: $video,
        isResponsive: false,
        bgVideo: true,
        autoplay: true,
        hasAudio: $video.hasClass('has-audio')
      });
    });
  },

  homepageTestimonialsCarouselModule: function () {
    var self = this;
    var $videos = self.$testimonialsCarouselModule.find('.video-wrapper');

    var moduleWrapper = document.querySelectorAll(
      '.testimonials-carousel-module'
    );

    moduleWrapper.forEach((module) => {
      self.dragToScroll(module, 600, false);
    });

    OneVideo.init({
      el: $videos,
      isResponsive: false,
      bgVideo: true,
      autoplay: true
    });
  },

  aboutModuleC: function () {
    var self = this;
    var moduleWrapper = document.querySelectorAll('.about-module-c');

    moduleWrapper.forEach((module) => {
      self.dragToScroll(module, 600, false);
    });
  },

  aboutModuleE: function () {
    var self = this;
    var moduleWrapper = document.querySelectorAll('.about-module-e');

    moduleWrapper.forEach((module) => {
      self.dragToScroll(module, 600, false);
    });
  },

  accordionsAndTabs: function () {
    var self = this;
    OneTabSystem.init({
      el: self.$content
    });
  },

  dragToScroll: function (moduleContainer, scrollButtonDistance, arrowsOnly) {
    var sliders = moduleContainer.querySelectorAll('.drag-to-scroll');

    var isDown = false;
    var startX;
    var scrollLeft;

    sliders.forEach((slider) => {
      var maxScroll = slider.scrollWidth - slider.offsetWidth;
      var scrollButtons = slider.querySelectorAll('.scroll-arrow');

      if (
        typeof scrollButtons != 'undefined' &&
        scrollButtons != null &&
        scrollButtons.length > 0
      ) {
        // not every slider has buttons
        var leftButton = slider.querySelector('.scroll-left');
        var rightButton = slider.querySelector('.scroll-right');

        if (maxScroll <= 0) {
          // disable both buttons if screen is too wide for element to be scrollable
          leftButton.classList.add('limit');
          rightButton.classList.add('limit');
        } else {
          leftButton.classList.add('limit'); // disable left button since we are at the start of the slider

          leftButton.addEventListener('click', (e) => {
            // left button controls
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;

            slider.scrollLeft = scrollLeft - scrollButtonDistance;
            rightButton.classList.remove('limit'); // when scrolling left - the right buttons becomes available again

            if (scrollLeft <= scrollButtonDistance) {
              // reaching start of the slider = no more scroll left
              leftButton.classList.add('limit');
            }
          });
          rightButton.addEventListener('click', (e) => {
            // right button controls
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;

            slider.scrollLeft = scrollLeft + scrollButtonDistance;
            leftButton.classList.remove('limit'); // when scrolling right - the left buttons becomes available again

            if (scrollLeft + scrollButtonDistance >= maxScroll) {
              // reaching end of the slider = no more scroll right
              rightButton.classList.add('limit');
            }
          });
        }
      }

      if (arrowsOnly == false) {
        slider.addEventListener('mousedown', (e) => {
          isDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          var x = e.pageX - slider.offsetLeft;
          var walk = (x - startX) * 1; // increase the number to increase scrolling speed
          slider.scrollLeft = scrollLeft - walk;

          if (
            typeof scrollButtons != 'undefined' &&
            scrollButtons != null &&
            scrollButtons.length > 0
          ) {
            // not every slider has buttons
            // disable left/right buttons when reaching start/end of slider
            if (slider.scrollLeft < 1) {
              leftButton.classList.add('limit');
            } else if (slider.scrollLeft >= 1) {
              leftButton.classList.remove('limit');
            }

            if (slider.scrollLeft >= maxScroll) {
              rightButton.classList.add('limit');
            } else if (slider.scrollLeft < maxScroll) {
              rightButton.classList.remove('limit');
            }
          }

          if (walk > 12 || walk < -12) {
            // dont grab if user moved mouse only slighlty after clicking (probably trying to click a link and not grab and scroll)
            slider.classList.add('active');
          }
        });
      }
    });
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  responsive: function () {
    var self = this;
    ORW.utilities.mediaCheck(
      function () {
        // Desktop actions
      },
      function () {
        // Mobile actions
      }
    );
  },

  isMobile: function () {
    if (ORW.responsive == 'small') {
      return true;
    }
    return false;
  }
});
